<template>
  <v-container
    text-xs-center
    class="pt-5 px-4"
  >
    <v-toolbar
      flat
      height="43px"
      color="#140C22"
      class="navigation-toolbar"
    >
      <v-layout
        row
        wrap
        align-center
      >
        <v-flex
          xs4
          style="text-align: start;"
        >
          <v-btn
            flat
            icon
            class="change-route-btn"
            block
            color="#fff"
            @click="backToProducts"
          >
            <v-icon class="mr-2 mb-1">
              $vuetify.icons.arrowLeftIcon
            </v-icon>
            Voltar
          </v-btn>
        </v-flex>
        <v-flex
          xs8
          style="text-align: end;"
        >
          <v-btn
            v-show="catalogueProductCount"
            flat
            icon
            class="change-route-btn"
            block
            color="#fff"
            @click="addToCatalogue"
          >
            Finalizar seleção
            <v-icon class="ml-2 mb-1">
              $vuetify.icons.arrowRightIcon
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-card
      v-if="!enterLoading"
      flat
      class="mx-2 animated fadeIn delay-1s"
    >
      <v-layout
        row
        wrap
        class="mt-4"
        align-center
      >
        <v-flex
          xs12
          class="catalogue-select text-xs-left mb-3"
        >
          Você está personalizando:
        </v-flex>
        <v-flex xs1>
          <div class="black-circle">
            <v-icon
              dark
              large
              style="heigth: 34px;"
            >
              {{ personalizeHeader.icon }}
            </v-icon>
          </div>
        </v-flex>
        <v-flex
          xs9
          class="catalogue-select__catalogue-name px-3"
        >
          {{ personalizeHeader.title }}
        </v-flex>
        <v-flex
          xs2
          class="text-xs-right"
        >
          <v-badge
            right
            overlap
            color="#FFADDE"
            :value="catalogueProductCount"
          >
            <template #badge>
              <span>
                {{ catalogueProductCount }}
              </span>
            </template>
            <v-btn
              depressed
              :disabled="!catalogueProductCount"
              color="#140C22"
              class="catalogue-product-count ma-0"
              @click="addToCatalogue"
            >
              <v-icon color="#fff">
                $vuetify.icons.catalogueIcon
              </v-icon>
            </v-btn>
          </v-badge>
        </v-flex>
        <v-flex xs12>
          <v-combobox
            ref="combobox"
            v-model="catalogueFilters"
            prepend-icon="$vuetify.icons.searchIcon"
            :items="allFilters"
            :menu-props="{
              closeOnContentClick: true
            }"
            dense
            small-chips
            clearable
            deletable-chips
            hide-selected
            label="Buscar"
            multiple
            no-data-text="Nenhum resultado encontrado..."
            @change="reset"
          />
        </v-flex>

        <v-layout
          row
          wrap
          class="order-by__txt"
          align-center
        >
          <v-flex
            xs6
            style="text-align: start;"
          >
            <v-btn
              id="personalize"
              depressed
              class="catalogue-select__personalize secondary-btn ml-0"
              color="#140C22"
              @click="selectAll"
            >
              <span style="text-transform: capitalize">
                + Selecionar Todos
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs4>
            <span class="order-by__arrows mr-1">
              ↑↓
            </span>
            <span>
              Ordenar por:
            </span>
          </v-flex>
          <v-flex xs2>
            <v-select
              v-model="catalogueSortAsc"
              :items="sort"
              item-text="label"
              append-icon=""
              filled
              :menu-props="{ bottom: true, offsetY: true }"
              dense
            >
              <template #selection="{ item }">
                <span class="order-by__select">
                  {{ item.label }}
                </span>
              </template>
              <template #item="{ item }">
                <v-list-tile-content class="order-by__select">
                  {{ item.label }}
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout
        row
        wrap
        justify-space-around
        class="mb-5 pb-2"
      >
        <v-flex
          v-for="product in filteredProducts"
          :key="product.sku"
          xs6
          md3
        >
          <ProductCard
            :product="product"
            can-select
          />
        </v-flex>
      </v-layout>
      <div style="margin-bottom: 150px">
        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <div slot="no-results">
            Sem mais resultados
          </div>
          <div slot="no-more">
            Sem mais resultados
          </div>
        </infinite-loading>
      </div>
    </v-card>
    <v-dialog
      v-model="discardDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, ao voltar você perderá toda a personalização deste catálogo.`"
        support-text="O que deseja fazer?"
        first-text="Continuar editando"
        second-text="Descartar edição"
        :first-action="() => { discardDialog = false }"
        :second-action="() => { $router.push('/produtos') }"
        :close="() => { discardDialog = false }"
      />
    </v-dialog>
    <v-dialog
      v-if="!enterLoading"
      v-model="maxFavoritesDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, você atingiu o número máximo de catálogos favoritos.`"
        support-text="Desfavorite pelo menos um catálogo para poder favoritar a sua personalização."
        first-text="Quero continuar"
        second-text="Voltar"
        :first-action="() => { maxFavoritesDialog = false }"
        :second-action="() => { $router.push('/produtos') }"
        :close="() => { maxFavoritesDialog = false }"
      />
    </v-dialog>
    <v-progress-circular
      v-if="enterLoading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import ProductCard from '@/components/ProductCard';
import ActionsDialog from '@/components/ActionsDialog';
import { mapGetters } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import { EventBus } from '@/event-bus.js';
import { FindCatalogueBySellerIdAndType } from '../apollo';
import { useZipperApi } from '../composables/useZipperApi';

const _ = require('lodash');
const Wade = require('wade');

const shortid = require('shortid');

const api = new APIService();
const { client } = useZipperApi();

export default {
  components: {
    ProductCard,
    ActionsDialog,
  },
  data: () => ({
    page: 0,
    size: 100,
    enterLoading: true,
    discardDialog: false,
    maxFavoritesDialog: false,
    awaitingSearch: false,
    allFilters: [],
    products: [],
    filters: null,
    search: null,
    selectAllProducts: false,
    totalProducts: null,
    selectingAllProducts: false,
    addingProducts: false,
    eventCatalogue: null,
    sort: [
      {
        label: 'Maior Preço',
        value: false,
      },
      {
        label: 'Menor Preço',
        value: true,
      },
    ],
    searchHeaders: {
      categories: { header: 'Categoria:' },
      sizes: { header: 'Tamanho:' },
      colors: { header: 'Cor:' },
      sectors: { header: 'Setor:' },
    },
    templateCatalogue: {},
    catalogue: {},
    loading: false,
    searchProducts: [],
  }),
  computed: {
    catalogueSortAsc: {
      get() {
        return this.$store.state.catalogueSortAsc;
      },
      set(value) {
        this.$store.commit('SET_CATALOGUE_SORT_ASC', value);
      },
    },
    finalProducts() {
      let { products } = this;

      if (this.catalogueFilters.length) {
        if (!this.searchProducts.length) this.handleSearch();
        products = this.searchProducts;
      }

      return products;
    },
    slicedProducts() {
      const sortDirection = this.catalogueSortAsc ? 'asc' : 'desc';
      let [withImage, withoutImage] = _.partition(this.finalProducts, 'mainImage');

      withImage = _.orderBy(withImage, ['preco'], [sortDirection]);
      withoutImage = _.orderBy(withoutImage, ['preco'], [sortDirection]);

      const sortedProducts = withImage.concat(withoutImage);

      return sortedProducts.slice(0, this.size * (this.page + 1));
    },
    filteredProducts() {
      const productsInStock = this.slicedProducts.filter((p) => (Math.max(...p.skus.map((sku) => sku.price)) || p.preco) > 0);
      return this.filterProductsSkusByTemplateCatalogue(productsInStock);
    },
    ...mapGetters([
      'getStore',
      'getCustomer',
      'getCatalogueSortAsc',
      'getCatalogue',
      'getProfile',
      'isMaxFavoriteCatalogues',
      'getCatalogueId',
      'getProducts',
    ]),
    catalogueFilters: {
      get() {
        return this.$store.state.catalogueFilters;
      },
      async set(value) {
        this.$store.commit('SET_CATALOGUE_FILTERS', value);
      },
    },
    catalogueProductCount() {
      return this.products.filter((product) => product.checkbox).length;
    },
    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },
    templateCatalogueId() {
      if (this.isCatalogue) return this.catalogue.templateCatalogueId;
      return this.getCatalogueId;
    },
    isCatalogue() {
      return this.getCatalogueId.length === 9;
    },
    personalizeHeader() {
      return {
        icon: this.isCatalogue ? '$vuetify.icons.heartOutlineIcon' : '$vuetify.icons.storeIcon',
        title: this.isCatalogue ? this.catalogue.favoriteName : this.templateCatalogue.name,
      };
    },
    catalogueIcon() {
      return this.isCatalogue
        ? '$vuetify.icons.heartOutlineIcon'
        : '$vuetify.icons.storeIcon';
    },
  },
  watch: {
    async catalogueFilters() {
      if (this.awaitingSearch) return;
      await this.handleSearch();
    },
    async getStore(store, oldVal) {
      if (store) {
        this.page = 0;
        this.products = this.getProducts;
      }
    },
  },
  async beforeMount() {
    this.maxFavoritesDialog = (this.isMaxFavoriteCatalogues && !this.isCatalogue);
  },
  mounted() {
    setTimeout(() => {
      this.enterLoading = false;
    }, 500);
  },
  methods: {
    async selectAll() {
      this.resetInfiniteLoading();
      this.$nextTick(() => {
        this.selectingAllProducts = true;
      });

      this.selectAllProducts = !this.selectAllProducts;
      this.filteredProducts.forEach((product) => {
        this.$set(product, 'checkbox', this.selectAllProducts);
      });

      this.$nextTick(() => {
        this.selectingAllProducts = false;
      });

      this.completeInfiniteLoading();
    },
    async addToCatalogue() {
      this.$nextTick(() => {
        this.addingProducts = true;
      });
      this.$store.dispatch(
        'addProductsToCatalogue',
        this.products.filter((product) => product.checkbox),
      );
      this.$nextTick(() => {
        this.addingProducts = false;
      });
      this.$router.push('/catalogo');
    },
    reset() {
      this.$refs.combobox.lazySearch = '';
      this.$refs.combobox.isMenuActive = false;
    },
    async infiniteHandler($state) {
      if (this.awaitingSearch) return;
      if (!this.templateCatalogue._id) await this.getTemplateCatalogue();
      if (!this.products.length) {
        this.products = this.getProducts;
        this.checkProducts(this.products);
        this.getFilters();
        $state.loaded();
        return;
      }

      if (this.slicedProducts.length < this.finalProducts.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    getFilters() {
      const skus = _.flatten(this.products.map((product) => product.skus));
      const filters = {
        categories: _.uniq(this.products.map((p) => p.categoria)).filter((p) => p),
        sizes: _.uniq(skus.map((s) => s.size)).filter((p) => p),
        colors: _.uniq(skus.map((s) => s.color)).filter((p) => p),
        sectors: _.uniq(this.products.map((p) => p.setor)).filter((p) => p),
      };

      Object.entries(filters).forEach((filter) => {
        if (filter[1].length) {
          this.allFilters = this.allFilters
            .concat(this.searchHeaders[filter[0]])
            .concat(filter[1]);
        }
      });
      this.filters = filters;
    },
    async getCatalogueByType(type) {
      const res = await this.$apollo.query({
        query: FindCatalogueBySellerIdAndType,
        variables: {
          sellerId: this.$auth.user.sub,
          type,
        },
        fetchPolicy: 'no-cache',
      });
      this.eventCatalogue = res.data.catalogueBySellerIdAndType;
    },
    emitSnackbar(color, text) {
      const snackBar = {};
      snackBar.text = text;
      snackBar.value = true;
      snackBar.color = color;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    resetInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    completeInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.loaded();
    },
    async getTemplateCatalogue() {
      if (this.isCatalogue) await this.getCatalogueBySeller();
      this.templateCatalogue = await client.chain.query
        .findTemplateCatalogueById({ templateCatalogueId: this.templateCatalogueId })
        .get({
          ...everything,
          corridors: {
            ...everything,
            priceRange: { ...everything, __typename: false },
            saleRange: { ...everything, __typename: false },
            __typename: false,
          },
        });
    },
    discountFilter(product, corridor) {
      if (
        !corridor.saleRange
        || (!corridor.saleRange.start && !corridor.saleRange.end)
      ) return true;
      const { start, end } = corridor.saleRange;
      const discount = Math.abs((product.price / product.oldPrice) - 1) * 100 || 0.0;
      return discount >= start && discount <= end;
    },
    priceFilter(product, corridor) {
      if (
        !corridor.priceRange
        || (!corridor.priceRange.start && !corridor.priceRange.end)
      ) return true;
      const { start, end } = corridor.priceRange;
      return product.price >= start && product.price <= end;
    },
    sizesFilter(product, corridor) {
      if (
        !corridor.sizes
        || !corridor.sizes.length
      ) return true;
      return corridor.sizes.includes(product.size);
    },
    filterProductsSkusByTemplateCatalogue(products) {
      return products.filter((product) => (
        product.skus.some((sku) => (
          this.templateCatalogue.corridors.some((corridor) => (
            this.priceFilter(sku, corridor)
              && this.discountFilter(sku, corridor)
              && this.sizesFilter(sku, corridor)
          ))
        ))
      ));
    },
    async getCatalogueBySeller() {
      this.catalogue = await client.chain.query
        .findCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.getCatalogueId,
          sellerId: this.$auth.user.sub,
        })
        .get({ ...everything });
    },
    checkProducts(products) {
      products.forEach((product) => {
        const cartProduct = this.getCatalogue.find((p) => p.idERP === product.idERP);
        if (
          cartProduct
          || (this.isCatalogue && this.catalogue.productIds.includes(product.idERP))
        ) product.checkbox = true;
      });
    },
    backToProducts() {
      if (!this.catalogueProductCount) this.$router.push('/produtos');
      this.discardDialog = true;
    },
    getSearchMap(products) {
      return products.map((p) => `${p.descricaoCurta} ${p.cor} ${p.setor} ${p.categoria} ${p.idERP} ${p.reference}`);
    },
    handleSearch() {
      let filters = this.catalogueFilters;
      let { products } = this;
      const { sizes, sectors } = this.filters || {};
      const size = filters.find((filter) => sizes && sizes.includes(filter));
      const sector = filters.find((filter) => sectors && sectors.includes(filter));

      if (size) {
        const filteredProducts = this.products.filter((p) => (
          p.skus.some((sku) => (
            sku.size === size
            && sku.currentStock > 0
            && sku.idLoja === this.getStore.id
          ))
        ));
        filters = filters.filter((input) => !sizes.includes(input));
        products = filteredProducts;
      }

      if (sector) {
        const filteredProducts = products.filter((p) => p.setor === sector);
        filters = filters.filter((input) => !sector.includes(input));
        products = filteredProducts;
      }

      let searchResults = products;
      filters = filters.join(' ').split(/\s+/).filter((f) => f);

      filters.forEach((filter) => {
        const search = Wade(this.getSearchMap(searchResults));
        searchResults = search(filter).map((sr) => searchResults[sr.index]);
      });

      this.searchProducts = searchResults;
      this.page = 0;
    },
  },
};
</script>

<style scoped lang="scss">

.toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-top: 60px;
}

.order-by {
  font-family: 'Nunito sans';
  font-style: normal;
  line-height: 14px;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
  }
  &__arrows {
    font-weight: 1000;
    font-size: 16px;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 10px;
  }
}

::v-deep .v-list__tile {
  border: 1px solid #F1F1F1;
  &__title {
    padding-left: 30px;
    font-size: 10px;
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    text-transform: lowercase;
  }
  &__title::first-letter {
    text-transform: uppercase;
  }
}

.catalogue-select {
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  &__copy-link {
    width: 85px;
    height: 26.5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 105px;
  }
  &__personalize {
    width: 138px;
    height: 26.5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 105px;
    color: white;
  }
  &__select {
    width: 90%;
  }
  &__catalogue-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    text-align: start;
  }
}

.black-circle {
  display: inline-block;
  background-color: #140C22;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.catalogue-product-count {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 42px;
  min-width: 42px;
  height: 42px;
  border-radius: 7px;
  cursor: pointer;
}

.change-route-btn {
  display: inline-block;
  width: auto;
  margin: 0 40px;
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 102%;
  text-transform: capitalize;
  border-radius: 20px;
}

.navigation-toolbar {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 105px;
}

.progress-circular {
  height: 50vh !important;
}

::v-deep .v-subheader {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #000;
  background-color: #F8F4F0;
  border-radius: 5px;
  height: 45.71px;
}

::v-deep .v-list {
  padding: 0;
}

::v-deep .v-select__slot {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 102%;
}

::v-deep .v-badge__badge {
  width: 18px;
  height: 18px;
}
</style>
